import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as themeworldTagActions from './themeworldTagsActions';

export type ThemeworldTagAction = ActionType<typeof themeworldTagActions>;

export interface IThemeworldTagStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: ITagType };
	readonly queries: { [queryKey: string]: ITagType[] };
}

export function themeworldTagsReducer(
	state = baseInitialState as IThemeworldTagStateType,
	action: ThemeworldTagAction,
) {
	const Reducer = new BaseReducer('themeworldTagsReducer', 'id');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
